import { render, staticRenderFns } from "./ModalProperty.vue?vue&type=template&id=0073063e&scoped=true&"
import script from "./ModalProperty.vue?vue&type=script&lang=js&"
export * from "./ModalProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073063e",
  null
  
)

export default component.exports